import React, {useRef, useState} from "react";
import styled from "styled-components";

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.button`
  padding: 0.5rem 1rem;
`;

const DropdownList = styled.ul<{open: boolean}>`
    display: ${props => props.open ? "block" : "none"};
    position: absolute;
    right: 0;
    top: 100%;
    background-color: var(--content-box-bg);
    border: 1px solid var(--content-box-border);
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: 120px;
    z-index: 10;
`;

const DropdownItem = styled.li`
  padding: 0.5rem 1rem;
  cursor: pointer;
  &:hover {
    background: var(--primary-blue-hover, #0074d9);
    color: #fff;
  }
`;

interface CustomSelectProps {
    options: string[];
    onSelect: (value: string) => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}

export function CustomSelect({options, onSelect, open, setOpen}: CustomSelectProps) {
    const [selected, setSelected] = useState<string | null>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open, setOpen]);

    return (
        <DropdownContainer ref={containerRef}>
            <DropdownList open={open}>
                {options.map(option => (
                    <DropdownItem
                        key={option}
                        onClick={() => {
                            setSelected(option);
                            setOpen(false);
                            onSelect(option);
                        }}
                    >
                        {option}
                    </DropdownItem>
                ))}
            </DropdownList>
        </DropdownContainer>
    );
}
